var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
import { useSuggestedSpaceQueryBase } from './useSuggestedSpaceQueryBase';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { useSafeFormData } from '../types/form';
import { useIsSuggestedSpacesEnabled } from './useIsSuggestedSpacesEnabled';
var GET_SUGGESTED_SPACES_FOR_EVENTS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query EventComposerGetSuggestedSpacesForEvents(\n    $input: GetSuggestedSpacesForEventsInput!\n  ) {\n    getSuggestedSpacesForEvents(input: $input) {\n      suggestedSpaces {\n        eventId\n        space {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query EventComposerGetSuggestedSpacesForEvents(\n    $input: GetSuggestedSpacesForEventsInput!\n  ) {\n    getSuggestedSpacesForEvents(input: $input) {\n      suggestedSpaces {\n        eventId\n        space {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
export function useEditEventSuggestedSpaceQuery(_a) {
    var _b, _c, _d;
    var levelId = _a.levelId, totalInviteesWithUserId = _a.totalInviteesWithUserId, _e = _a.enabled, enabled = _e === void 0 ? true : _e;
    var locationId = useEventComposerGlobalContext().locationId;
    var suggestedSpacesEnabled = useIsSuggestedSpacesEnabled();
    var form = useSafeFormData();
    var eventIdForEdit = form === null || form === void 0 ? void 0 : form.eventId;
    var _f = useSuggestedSpaceQueryBase({
        enabled: !!suggestedSpacesEnabled && !!locationId,
        locationId: locationId,
        levelId: levelId,
    }), debouncedRange = _f.debouncedRange, levelIdsForPreferences = _f.levelIdsForPreferences, preferredSpaceCapacity = _f.preferredSpaceCapacity, commonSkipReasons = _f.commonSkipReasons;
    var skipEvents = commonSkipReasons || !eventIdForEdit;
    var variables = skipEvents || !locationId || !eventIdForEdit
        ? undefined
        : {
            input: {
                algorithm: null,
                events: [
                    {
                        id: eventIdForEdit,
                        startTime: debouncedRange.start,
                        endTime: debouncedRange.end,
                        preferredSpaceCapacity: preferredSpaceCapacity,
                    },
                ],
                spaceFilters: {
                    locationIds: [locationId],
                },
                spacePreferences: {
                    levelIds: levelIdsForPreferences,
                },
            },
        };
    var _g = useQuery(GET_SUGGESTED_SPACES_FOR_EVENTS, {
        skip: skipEvents || totalInviteesWithUserId < 2 || !enabled,
        variables: variables,
        fetchPolicy: 'cache-and-network',
    }), data = _g.data, loading = _g.loading;
    var rows = (_c = (_b = data === null || data === void 0 ? void 0 : data.getSuggestedSpacesForEvents) === null || _b === void 0 ? void 0 : _b.suggestedSpaces) !== null && _c !== void 0 ? _c : [];
    var match = rows.find(function (r) { return r.eventId === eventIdForEdit; });
    var space = match === null || match === void 0 ? void 0 : match.space;
    return {
        suggestedSpaceId: (_d = space === null || space === void 0 ? void 0 : space.id) !== null && _d !== void 0 ? _d : null,
        loading: loading,
    };
}
var templateObject_1;
